import { SideCard } from '@components/side-card'
import * as React from 'react'

export const GastroCardSideCard = (): JSX.Element => (
  <SideCard
    className="d-lg-block d-none"
    image={<img src={require('@assets/images/gastro-voucher-label.jpg')} alt="Gastro voucher label" />}
  />
)
